import { FormSection, ToggleField } from './FormSection';
import { ToggleList } from '../serviceFormStyles';
import { isPaidService } from '../serviceFormUtils';

const EventOptionsSection = ({ inputs, updateInputs }) => {
  const toggle = (name) => () => updateInputs({ [name]: !inputs[name] });
  const isPaidEvent = isPaidService(inputs);

  return (
    <FormSection
      id="opciones"
      number={5}
      title="Opciones del evento"
      description="Ajustes adicionales de inscripción y asistencia."
    >
      <ToggleList>
        <ToggleField
          name="closed"
          label="Inscripciones cerradas"
          checked={inputs.closed}
          onChange={toggle('closed')}
          hint="El evento no recibe inscripciones mientras esta opción esté activa."
        />
        {inputs.eventSlugname !== 'Presentacion_de_Bebes' && (
          <ToggleField
            name="presentingBabies"
            label="Se presentarán bebés en este servicio"
            checked={inputs.presentingBabies}
            onChange={toggle('presentingBabies')}
          />
        )}
        <ToggleField
          name="volunteerDonation"
          label="Se recibe donación voluntaria"
          checked={inputs.volunteerDonation}
          onChange={toggle('volunteerDonation')}
        />
        <ToggleField
          name="certificated"
          label="Tiene certificado"
          checked={inputs.certificated}
          onChange={toggle('certificated')}
          hint="Recuerda verificar que el certificado de este evento esté montado."
        />
        {!isPaidEvent && !inputs.multipleEvents && (
          <ToggleField
            name="oneForManyEvents"
            label="Una sola inscripción para la serie de eventos consecutivos"
            checked={inputs.oneForManyEvents}
            onChange={() =>
              updateInputs({ oneForManyEvents: !inputs.oneForManyEvents, multipleEvents: false })
            }
            hint="Recuerda crear varios eventos consecutivos."
          />
        )}
        {!isPaidEvent && !inputs.oneForManyEvents && (
          <ToggleField
            name="multipleEvents"
            label="Se pueden elegir varios días/eventos de asistencia"
            checked={inputs.multipleEvents}
            onChange={() =>
              updateInputs({ multipleEvents: !inputs.multipleEvents, oneForManyEvents: false })
            }
            hint="Recuerda crear varios eventos consecutivos."
          />
        )}
      </ToggleList>
    </FormSection>
  );
};

export default EventOptionsSection;
